import { createContext, useContext } from 'react';

export type PurchaseSelections =
  | 'oneTimePurchase'
  | 'membership'
  | 'subscription';

export type PurchaseOptionsContextType = {
  selectedOption: PurchaseSelections;
  setSelectedOption: (value: PurchaseSelections) => void;
};

export const SelectedOptionContext = createContext<
  PurchaseOptionsContextType | undefined
>(undefined);

export const useSelectedOptionsContext = () => {
  const value = useContext(SelectedOptionContext);

  if (value === undefined) {
    throw new Error(
      'useSelectedOptions must be used within a  SelectedOptionContextProvider',
    );
  }

  return value;
};
